import DialogComponent from "components/Dialog";

import CheckBox from "components/CheckBox";
import Quest from "components/Quest";

export default class PaymentAbstractDialog extends DialogComponent {

    constructor(props) {
        super(props);

        this.defaultState = {
            ...this.state,
            type: "",
            value: 0,
            comment: "",
            bonusMisty: {
                count: 0,
                checkBonusMisty: false,
                externalOrderId: false,
            },
        };

        this.state = {
            ...this.defaultState,
            checkBonusMisty: false,
        };

        this.useTooltip = true;
    }

    get balanceLabel() {
        return "";
    }

    show(balance, info, hideCb) {
        this.state.disableSave = true;
        this.balance = balance || {};
        this.info = info || {};
        this.hideCb = hideCb;
        this.state.targetClientId = null;

        super.show();
    }

    async onShow() {
        const { id, discount, createdTime } = this.info;
        const createdCheck = (new Date(createdTime) > new Date("2024-07-01"));
        if (!discount && createdCheck) {
            const soft = await this._request.bonusMisty.soft(id);
            if (soft?.data?.availableBonusesToWriteDown || soft?.data?.availableBonusesToChargeIn) {
                const { externalOrderId, availableBonusesToWriteDown } = soft.data;
                const bonusMisty = { ...this.state.bonusMisty, externalOrderId, count: availableBonusesToWriteDown };
                this.setState({ bonusMisty });
            }
        }
    }

    joinSaveInfo(info) {
        return info;
    }

    getSum() {
        return 1000000000;
    }

    showAllSum() {
        return false;
    }

    showZeroItem() {
        return true;
    }

    getItemMaxSum(bSum) {
        return bSum;
    }

    async save() {
        this.hide();

        const { bonusMisty, comment } = this.state;
        const { totalSum, paidSum, createdTime } = this.info;

        if (!this.hideCb?.apply)
            return;

        const { type, value } = this.state;
        const item = this.balance[type];

        this.hideCb(this.joinSaveInfo({
            /*type: item?.name || "",*/
            sum: value || 0,
            hasCheck: false,
            paymentWayId: item?.id,
            totalSum,
            paidSum,
            bonusMisty,
            comment,
            createdAt: createdTime
        }));
    }

    onTypeChange(key, all) {
        //const { bonusMisty } = this.state;
        this.state.type = this.state.type === key ? "" : key;
        //this.changeState("bonusMisty", { ...bonusMisty, checkBonusMisty: false });
        this.changeValue(0);
    }

    onChangeBonusMisty(value) {
        const { bonusMisty, type } = this.state;
        if (!type)
            return this.showError("Для списания бонусов Misty выберите форму оплаты!");

        if (value) {
            const n = this.balance[type]?.sum || 0;
            const sum = this.getSum();
            /*if ((n + bonusMisty.count) < sum) {
                this.changeValue(0);
            } else {
                this.changeValue(sum - bonusMisty.count);
                this.changeState("bonusMisty", { ...bonusMisty, checkBonusMisty: value });
            }*/
            if (!((n + bonusMisty.count) < sum)) {
                this.changeValue(sum - bonusMisty.count);
                this.changeState("bonusMisty", { ...bonusMisty, checkBonusMisty: value });
            } else {
                this.showError("Не достаточно средств на оплату счета! Бонусы Misty не списать!");
            }
        } else
            this.changeState("bonusMisty", { ...bonusMisty, checkBonusMisty: value });
    }

    changeValue(value) {
        const disableSave = (!value || value < 1 || !this.validInfo());
        this.setState({ value, disableSave });
    }

    validInfo() {
        return true;
    }

    renderMainBlock() {
        return <></>;
    }

    renderContent() {
        const { type, value, bonusMisty } = this.state;
        const { mistyClient, totalSum, paidSum, discount, createdTime } = this.info;
        const sum = this.getSum();
        const acceptMisty = ((paidSum >= totalSum / 2) && !discount);
        let textForMisty = "";
        if (mistyClient) {
            if (discount) {
                textForMisty = "Для оплаты бонусами Misty счет должен быть без скидки";
            }
        }

        const createdCheck = (new Date(createdTime) > new Date("2024-07-01"));
        //const showBonusMisty = mistyClient && !!bonusMisty.count && paidSum === 0 && !discount && type !== "30" && type !== "51";
        /*const showBonusMisty = createdCheck && mistyClient && !discount && type !== "30" && type !== "51" &&
            (totalSum === (value + paidSum) || bonusMisty.checkBonusMisty);*/
        const acceptPayWithMisty = ["1", "10", "20", "40"];
        (Object.keys(this.balance) || []).forEach(pay => {
            const it = this.balance[pay];
            if (it?.title?.includes("ИП Артеменко"))
                acceptPayWithMisty.push(it?.id + "");
        });

        const showBonusMisty = createdCheck && mistyClient && !discount && (!type || (acceptPayWithMisty).includes(type));

        return (
            <div className="content flex col gap24">
                {this.renderMainBlock(this.info, sum)}
                {this.insertInput({
                    ref: el => this.comment = el,
                    itemStyle: "flex1",
                    label: "main.comment",
                    placeHolder: "expenses.commentOperation",
                    onChange: this.changeState.bind(this, "comment")
                })}
                <div className="flex col gap8">
                    <div className="text p2 rowInfoTitle">{this.tr(this.balanceLabel)}</div>
                    {Object.keys(this.balance).map((key, id) => {
                        if (key === "total" || key === "53")
                            return false;
                        const checked = type === key;
                        const n = this.balance[key].sum || 0;
                        const max = this.getItemMaxSum(n, sum);
                        let all = n < sum ? n : sum;
                        if (bonusMisty.checkBonusMisty) {
                            const all1 = sum - bonusMisty.count;
                            if (all < all1)
                                all = 0;
                            else
                                all = all1;
                        }
                        const hidden = n < 1 && !this.showZeroItem();
                        const st = hidden ? { display: "none" } : {};

                        return (key !== "53" || mistyClient) &&
                            (<div key={id} className="flex col start gap8" style={st}>
                                <div className="flex centerV gap8">
                                    <CheckBox
                                        checked={(key === "53" && !acceptMisty) ? false : checked}
                                        title={this.balance[key].title}
                                        titleStyle={`title hand ${(key === "53" && !acceptMisty) ? "disabled" : ""}`}
                                        onClick={(key === "53" && !acceptMisty) ? null : this.onTypeChange.bind(this, key, all)}
                                    />
                                    <div className="colSec text p1">{this._helper.number.toSum(n)}</div>
                                </div>

                                {checked && key !== "53" && (
                                    <div className="flex gap24">
                                        <div></div>
                                        <div className="flex col gap16">
                                            <div className="flex centerV gap8">
                                                {this.insertInput({
                                                    type: "number",
                                                    value,
                                                    readonly: bonusMisty.checkBonusMisty,
                                                    inputProps: {
                                                        min: 1,
                                                        max,
                                                        step: 1,
                                                    },
                                                    validator: this._helper.inputValidators.number,
                                                    onChange: this.changeValue.bind(this)
                                                })}
                                                {this.showAllSum() && (
                                                    <div
                                                        className="text p1 colSec2 hand"
                                                        onClick={this.changeValue.bind(this, all)}
                                                    >
                                                        {this.tr("invoice.wholeAmount")}
                                                    </div>
                                                )}
                                            </div>
                                            <div></div>
                                        </div>
                                    </div>
                                )}
                            </div>
                            );
                    })}
                    {showBonusMisty && <>
                        {/*<div className="text p2" style={{ width: "350px" }}>
                            Для списания бонусов Misty сначала необходимо выбрать форму оплаты. Так же баланс должен покрывать оставшуюся сумму счета. Для ввода значения нажмите "Вся сумма"
                    </div>*/}
                        <div key={"bonusMisty"} className="flex col start gap8">
                            <div className="flex centerV gap8">
                                <CheckBox
                                    checked={discount ? false : bonusMisty.checkBonusMisty}
                                    title={"Бонус Misty"}
                                    titleStyle={`title hand`}
                                    onClick={this.onChangeBonusMisty.bind(this, !bonusMisty.checkBonusMisty)}
                                />
                                <div className="colSec text p1">{this._helper.number.toSum(bonusMisty.count)}</div>
                                <Quest textTooltip={`Списать или начислить бонусы можно только при полной оплате счёта.
При частичной оплате списание недоступно. Так же списать бонусы Misty можно не больше 25% от суммы счёта`} />
                            </div>
                        </div></>}
                    {textForMisty && <div className="text p2">
                        {textForMisty}
                    </div>}
                </div>
            </div>
        );
    }
}
